import SucceedPayment from "./SucceedPayment";

export default SucceedPayment;
